import { useState } from 'react';
import { comics, categories } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function RecommendGrid() {
  const [activeTab, setActiveTab] = useState('all');

  const filteredComics = activeTab === 'all'
    ? comics
    : comics.filter((c) => c.categories.includes(activeTab));

  const displayCategories = categories.filter((c) =>
    ['all', 'romance', 'fantasy', 'bl', 'action', 'thriller'].includes(c.slug)
  );

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              <i className="ri-thumb-up-line text-secondary-500 mr-2"></i>
              精品推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">精选优质韩漫作品，精彩不容错过</p>
          </div>
        </div>

        <div className="flex items-center gap-1.5 mb-6 overflow-x-auto pb-1 flex-wrap">
          {displayCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveTab(cat.slug)}
              className={`px-1 py-1 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeTab === cat.slug
                  ? 'px-4 py-1.5 bg-primary-500 text-background-50'
                  : 'px-4 py-1.5 bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {filteredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="small" />
          ))}
        </div>
      </div>
    </section>
  );
}